(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["minicart"]) return;
  try {
    
(function () {
  if (window._pnhSwapInit) return;
  window._pnhSwapInit = true;

  window.pnhSwap = function (addId, addQty, removeKey) {
    var oldVariantId = removeKey.split(':')[0];
    var updates = {};
    updates[oldVariantId] = 0;
    updates[addId] = addQty;
    window.liquidAjaxCart.update({ updates: updates });
  };
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const wrapper = document.querySelector('.product-recommendations-wrapper');
    if (!wrapper) return;

    const url = wrapper.dataset.url;
    if (!url) return;

    const observer = new IntersectionObserver(function (entries, obs) {
      if (!entries[0].isIntersecting) return;
      obs.unobserve(wrapper);

      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('.product-recommendations-wrapper');
          if (inner && inner.innerHTML.trim()) {
            wrapper.innerHTML = inner.innerHTML;
            if (window.Alpine) Alpine.initTree(wrapper);
          }
        })
        .catch(function () {});
    }, { rootMargin: '0px 0px 300px 0px' });

    observer.observe(wrapper);
  })();

  } catch(e) { console.error(e); }
})();
})();
